import { MdOpenInNew } from "react-icons/md";

export default function StandardLink({isNewWindow, children, ...props}) {
    return <a 
        {...props} 
        target="_blank" 
        rel="noopener noreferrer">
            {children}
            {isNewWindow && <MdOpenInNew title="Open in new window" className="linkNewWindow" />}
    </a>
}